import React from 'react';
import { Dialog, DialogContent, CircularProgress, Typography, Button } from '@material-ui/core';

export const LoadingModal = ({ open }) => (
  <Dialog open={open} maxWidth="xs" fullWidth>
    <DialogContent style={{ textAlign: 'center', padding: '24px' }}>
      <CircularProgress size={40} style={{ marginBottom: '16px' }} />
      <Typography variant="h6">
        Procesando reporte...
      </Typography>
    </DialogContent>
  </Dialog>
);

export const ErrorModal = ({ open, onClose }) => (
  <Dialog open={open} maxWidth="xs" fullWidth>
    <DialogContent style={{ textAlign: 'center', padding: '24px' }}>
      <Typography variant="h6" color="error" style={{ marginBottom: '16px' }}>
        Error
      </Typography>
      <Typography variant="body1" style={{ marginBottom: '24px' }}>
        Ha ocurrido un error al procesar su solicitud. Por favor, intente nuevamente.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={onClose}
        className="actions-table__button"
      >
        Aceptar
      </Button>
    </DialogContent>
  </Dialog>
);

export default LoadingModal; 